<mat-toolbar class="footer">
    <span>
        Sistema Automatizado de Cobrança de Pedágios 
    </span>
</mat-toolbar>